import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

// COMPONENTS
import Header from '../../FilterPanelHeader'
import SearchId from './filter/SearchId'
import SearchTitle from './filter/SearchTitle'
import SortBy from './filter/SortBy'
import JobFilter from './filter/JobFilter'
import Button from '../../ui-elements/Button'

// ICONS
import { FaExchangeAlt } from 'react-icons/fa'

// ACTIONS
import { TOGGLE_MODAL } from '../../../redux/actions/uiActions'

const FilterPanel = () => {
  const dispatch = useDispatch()
  const locked = useSelector(state => !state.jobs.currentClinic.crawler)
  const openModal = () => dispatch({ type: TOGGLE_MODAL, modal: 'swapId' })

  return (
    <div className='filter-panel' style={{ height: '490px' }}>
      <Header text='Stellen Filtern' />
      <JobFilter />
      <SearchId />
      <SearchTitle />
      <Button
        onClick={openModal}
        disabled={locked}
        text='Titel vergleichen'
        color={locked ? 'gray' : 'blue'}
        style={{ width: '83%' }}
        iconSize={16}
      >
        <FaExchangeAlt />
      </Button>
      <SortBy />
    </div>
  )
}

export default FilterPanel
